import LocationAmenityIcon from "./LocationAmenityIcon";
import useContent from "@lib/use_content";

export default function AmenityLegend({ types = [] }: { types: string[] }) {
  const { data, loading, error } = useContent([
    "beLocAmenIconH",
    "beLocAmenIconNP",
    "beLocAmenIconP",
    "beLocAmenIconR",
    "beLocAmenIconV",
  ]);

  const cleanedTypes = types.filter((e) => e !== null);
  if (cleanedTypes.length === 0) return null;

  return (
    <div className="flex gap-x-8 gap-y-2 flex-wrap items-center mt-4 mb-3">
      {cleanedTypes.map((type) => {
        return (
          <div className="flex gap-x-2 items-center" key={type}>
            <LocationAmenityIcon type={type} />
            <div className="text-sm">
              {type == "P" && data?.content.beLocAmenIconP}
              {type == "R" && data?.content.beLocAmenIconR}
              {type == "V" && data?.content.beLocAmenIconV}
              {type == "H" && data?.content.beLocAmenIconH}
              {type == "NP" && data?.content.beLocAmenIconNP}
            </div>
          </div>
        );
      })}
    </div>
  );
}
